export * from './meta-desctiption-translation';

